<template>
  <div class="right-side-bar mt-2">
    <ul class="d-flex m-0 pl-0 pl-lg-5">
      <li class="nav-item dropdown" v-if="$page.props.auth.user.role == 'mtd'">
        <a class="nav-link" role="button" data-toggle="dropdown" aria-expanded="false" title="View Locations" id="location_icon">
          <i class="fa fa-map-marker-alt nav-icon"></i>
          <span class="badge badge-secondary badge-round navbar-badge">{{ locationActionCount }}</span>
        </a>
        <div class="dropdown-menu drop-wide dropdown-menu-right animate slideIn p-2" aria-labelledby="location_icon">
          <p class="text-secondary mb-1"><i class="fas fa-map-marker-alt text-primary mr-2"></i>Current Location</p>
          <Multiselect
            :value="current_location_id"
            :options="$page.props.auth.user.locations" 
            :searchable="true"
            id="location_select" 
            class="w-100"
            placeholder="Select Location"
            @change="selectLocation" 
            @clear="clearLocation"
          />
          <div v-if="current_location_id > 0" class="pb-2">
            <div v-for="action in locationActions" :key="action.id">
              <div class="action-item lh-small w-100 px-3 py-2" v-if="action.type == 'order'" @click="showRequest(action)">
                <DropdownItemIcon icon="fa-truck">
                  <span v-if="action.user.first_name" class="text-size-small">
                    {{ moment(action.date).format('h:mm A') }} - Deliver ordered items to {{ action.user.first_name }} {{ action.user.last_name }}
                  </span>

                  <span v-else>
                    {{ moment(action.date).format('h:mm A') }} - Deliver ordered items for order #{{action.id}}
                  </span>
                </DropdownItemIcon>
              </div>
              <div class="action-item lh-small w-100 px-3 py-2" v-if="action.type == 'return'" @click="showRequest(action)">
                <DropdownItemIcon icon="fa-box">
                  <span v-if="action.user.first_name" class="text-size-small">
                    {{ moment(action.date).format('h:mm A') }} - Collect items for return by {{ action.user.first_name }} {{ action.user.last_name }}
                  </span>

                  <span v-else>
                    {{ moment(action.date).format('h:mm A') }} - Collect items for return #{{action.id}}
                  </span>
                </DropdownItemIcon>
              </div>
            </div>
          </div>
        </div>
      </li>            
      <li class="nav-item dropdown">
        <a class="nav-link" role="button" title="View Notifications" data-toggle="dropdown" aria-expanded="false" id="action_icon">
          <div @click="getRequests">
            <i class="fa fa-bell nav-icon"></i>
            <span class="badge badge-secondary badge-round navbar-badge notification-badge">{{ actionCount }}</span>
          </div>
        </a>
        <div class="dropdown-menu drop-wide dropdown-menu-right animate slideIn p-0" aria-labelledby="action_icon">
          <div v-for="action in actions" :key="action.id">
            <div class="action-item p-2 w-100 lh-small" v-if="action.type == 'plan'" @click="showRequest(action)">
              <DropdownItemIcon icon="fa-clock">
                <span class="font-weight-bold">{{ moment(action.date).format('h:mm A') }} - </span>
                <span v-if="action.user.first_name"> 
                  Payment term request by {{ action.user.first_name }} {{ action.user.last_name }}
                </span>

                <span v-else>
                  Payment term request for order #{{action.id}}
                </span>
              </DropdownItemIcon>
            </div>
            <div class="action-item p-2 w-100 lh-small" v-else-if="action.type == 'balance'" @click="showRequest(action)">
              <DropdownItemIcon icon="fa-hand-holding-usd">
                <span class="font-weight-bold">{{ moment(action.date).format('h:mm A') }} - </span> 
                <span v-if="action.user.first_name">
                  Account balance request by {{ action.user.first_name }} {{ action.user.last_name }}
                </span>

                <span v-else-if="action.id">
                  Account balance request for order #{{action.id}}
                </span>

                <span v-else>Account balance request by guest user</span>
              </DropdownItemIcon>
            </div>
            <div class="action-item p-2 w-100 lh-small" v-else-if="action.type == 'cash'" @click="showRequest(action)">
              <DropdownItemIcon icon="fa-hand-holding-usd">
                <span class="font-weight-bold">{{ moment(action.date).format('h:mm A') }} - </span> 
                <span>Confirm cash payment accepted from {{ action.user.first_name }} {{ action.user.last_name }}</span>
              </DropdownItemIcon>
            </div>
            <div class="action-item p-2 w-100 lh-small" v-else-if="action.type == 'cart'" @click="showRequest(action)">
              <DropdownItemIcon icon="fa-shopping-cart">
                <span class="font-weight-bold">{{ moment(action.date).format('h:mm A') }} - </span> 
                <span>{{ this.$page.props.auth.user.mtd.company_name}} sent a cart</span>
              </DropdownItemIcon>
            </div>
            <div class="action-item p-2 w-100 lh-small" v-else-if="action.type == 'taxexempt'" @click="showRequest(action)">
              <DropdownItemIcon icon="fa-calculator">
                <span class="font-weight-bold">{{ moment(action.date).format('h:mm A') }} - </span> 
                <span> {{ action.user.first_name }} {{ action.user.last_name }} requested tax exempt status</span>
              </DropdownItemIcon>
            </div>              
            <div class="action-item lh-small w-100 px-3 py-2" v-if="action.type == 'order'" @click="showRequest(action)">
              <DropdownItemIcon icon="fa-truck">
                <span v-if="action.user.first_name" class="text-size-small">{{ moment(action.date).format('h:mm A') }} - Deliver ordered items to {{ action.user.first_name }} {{ action.user.last_name }}</span>

                <span v-else>{{ moment(action.date).format('h:mm A') }} - Deliver ordered items for order #{{action.id}}</span>
              </DropdownItemIcon>
            </div>
            <div class="action-item lh-small w-100 px-3 py-2" v-if="action.type == 'return'" @click="showRequest(action)">
              <DropdownItemIcon icon="fa-box">
                <span v-if="action.user.first_name" class="text-size-small">
                  {{ moment(action.date).format('h:mm A') }} - Collect items for return by {{ action.user.first_name }} {{ action.user.last_name }}
                </span>

                <span v-else>
                  {{ moment(action.date).format('h:mm A') }} - Collect items for return #{{action.id}}
                </span>
              </DropdownItemIcon>
            </div>
          </div>
        </div>
      </li>
      <li class="nav-item dropdown">
        <a class="nav-link" role="button" title="View Cart Items" data-toggle="dropdown" aria-expanded="false" id="cart_icon">
          <i class="fa fa-shopping-cart nav-icon"></i>
          <span class="badge badge-info badge-round text-white navbar-badge">{{ $page.props.auth.user.cart_items.length }}</span>
        </a>
        <div class="dropdown-menu drop-wide dropdown-menu-right animate slideIn p-0" aria-labelledby="action_icon">
          <CartDropdown
          :items="$page.props.auth.user.cart_items"
          :routes="{
            view: 'cart.view',
            checkout: 'cart.checkout'
          }" 
          :total="$page.props.auth.user.cart_total" />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  import Multiselect from '@vueform/multiselect'
  import DropdownItemIcon from '@/Shared/DropdownItemIcon'
  import Helpers from '@/Helpers.js'
  import moment from 'moment'
  import CartDropdown from '@/Components/Nav/CartDropdown'

  export default {
    created() {
      this.moment = moment
    },
    props: {
      actions: Array,
      locationActions: Array,
      actionCount: Number,
      locationActionCount: Number,
      current_location_id: Number
    },
    components: {
      Multiselect,
      DropdownItemIcon,
      CartDropdown
    },
    methods: {
      showRequest(action) {
        this.$emit('showRequest', action)
      },
      selectLocation(id) {
      if (id) {
        axios.get(this.route('mtd.location.arrive', id)).then((res) => {
          this.$emit('checkRequests')
          this.$emit('getRequests')
       });
      }
    },
    getRequests() {
      this.$emit('getRequests')
    },
    clearLocation() {
      axios.get(this.route('mtd.location.leave')).then((res) => {
        this.$emit('checkRequests')
        this.$emit('getRequests')
       });
      },
      formatCurrency: Helpers.formatCurrency
    }
  }
</script>
